import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id 0EB91CE4-3223-4799-9BB7-3BA0C923BC40
 * name table-column-plus-after
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/table-column-plus-after.svg
 * tags
 * - Text / Content / Format 
 */
export const TableColumnPlusAfterIcon = createSvgIcon(<><path d="M11,2A2,2 0 0,1 13,4V20A2,2 0 0,1 11,22H2V2H11M4,10V14H11V10H4M4,16V20H11V16H4M4,4V8H11V4H4M15,11H18V8H20V11H23V13H20V16H18V13H15V11Z" /></>, 'TableColumnPlusAfterIcon');
export default TableColumnPlusAfterIcon